import { Injectable } from '@angular/core';

@Injectable()
export class AppService {
  constructor() { }
}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/app.service.ts